//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as React from 'react'
import { ReactElement } from 'react'
import { Typography } from '@mui/material'

import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { DatePicker } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'
import { logOT } from '@shared/loggingShared'

export default function EditDate(props: {
  propName: string
  label: string
  errors: any
  setValue: any
  register: any
  defaultValue: any
  onChange?: (e: Event) => void
}): ReactElement {
  const { propName, label, setValue, register, defaultValue, errors } = props
  // const castErrors = errors as Record<string, Error>
  logOT.info('Date defaultValue= ', propName, defaultValue, typeof defaultValue, register(propName))
  // const d = defaultValue as Date ?? new Date()
  //
  // let month = `${(d.getMonth() + 1)}`
  // let day = `${d.getDate()}`
  // const year = `${d.getFullYear()}`
  //
  // if (month.length < 2) { month = '0' + month }
  // if (day.length < 2) { day = '0' + day }
  //
  // const defaultValue2 = [year, month, day].join('-')

  logOT.debug('Edit date ', props.onChange)
  //  logOT.debug('Date defaultValue2', defaultValue2)

  // const localOnChange = (e: Event): void => {
  //   logOT.info('localOnChange', e)
  //   register(propName).onChange(e).then(() => {
  //     if (props.onChange) {
  //       logOT.info('localOnChange props.onChange', e)
  //       props.onChange(e)
  //     }
  //   })
  //     .catch((err: Error) => {
  //       logOT.error('err', err)
  //     })
  // }

  // return (
  //   <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
  //       <DateField label="Date" format="YYYY/MM/DD" defaultValue={dayjs('2022-04-17')} />
  //     </LocalizationProvider>
  // )
  logOT.info('lan ', window.navigator?.language)

  const dateFormatOptions = Intl.DateTimeFormat(window.navigator?.language).formatToParts()

  const dateFormatString = dateFormatOptions
    .map((part) => {
      switch (part.type) {
        case 'day':
          return 'DD' // Day of the month (two digits)
        case 'month':
          return 'MM' // Month (two digits)
        case 'year':
          return 'YYYY' // Full year (four digits)
        default:
          return part.value // Retain other parts like separators, e.g., "/", "-"
      }
    })
    .join('')
  const locale = window.navigator?.language

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <DatePicker
          onChange={(newValue: Dayjs | null) => {
            const v = newValue?.format('YYYY-MM-DD ')
            setValue(propName, v)
            // register(propName).onChange(v).then(() => {
            //   if (props.onChange && v) {
            //     logOT.info('localOnChange props.onChange', v)
            //   //  props.onChange(v)
            //   }
            // })
          }}
          label={label}
          format={dateFormatString}
          defaultValue={dayjs(defaultValue)}
        />
      </LocalizationProvider>

      {/* <TextField */}
      {/* InputProps={{ */}
      {/*  onChange: localOnChange, */}
      {/*  format: 'yyyy' */}
      {/* }} */}
      {/* InputLabelProps={{ */}
      {/*  shrink: true */}
      {/* }} */}
      {/* inputProps={{ */}
      {/*  'data-testid': propName, */}
      {/*  format: 'yyyy-mm' */}
      {/* }} */}
      {/* defaultValue={defaultValue} */}
      {/* required */}
      {/* id={propName} */}
      {/* label={label } */}
      {/* fullWidth */}
      {/* format={'yyyy'} */}
      {/* type="date" */}
      {/* margin="dense" */}
      {/* {...register(propName)} */}
      {/* error={(castErrors[propName] != null)} */}
      {/* /> */}

      {/* <Controller */}
      {/*  as={DesktopDatePicker} */}
      {/*  name={propName} */}
      {/*  control={control} */}
      {/*  valueName={propName} */}
      {/*  {...register(propName)} */}
      {/*  error={(castErrors[propName] != null)} */}
      {/*  className="input" */}
      {/*  placeholderText="Select date" */}
      {/*  onChange={(select: any) => { */}
      {/*    logOT.debug('select', select) */}
      {/*  }} */}
      {/* /> */}
      {/* <DesktopDatePicker */}
      {/*  minDate={new Date()} */}
      {/*  id={propName} */}

      {/*  defaultValue={defaultValue} */}
      {/*  required */}
      {/*  fullWidth */}
      {/*  margin="dense" */}
      {/*  {...register(propName)} */}
      {/*  renderInput={(params) => { */}
      {/*    logOT.debug('params', params) */}
      {/*    logOT.debug('register(propName', register(propName)) */}
      {/*    // textField = (<TextField {...params} {...register(propName)} value={value}/>) */}
      {/*    const inputProps = { ...params.inputProps } */}
      {/*    // inputProps.type = 'date' */}
      {/*    textField = (<TextField InputProps={params.InputProps} */}
      {/*                            inputProps={inputProps} */}
      {/*                            inputRef = {params.inputRef} */}
      {/*                            ref = {params.ref} */}
      {/*                            InputLabelProps={{ */}
      {/*                              shrink: true */}
      {/*                            }} */}
      {/*                            error={false} */}
      {/*                            required */}
      {/*                            id={propName} */}
      {/*                            label={label} */}
      {/*                            fullWidth */}
      {/*                            margin="dense" */}
      {/*      {...register(propName)} */}
      {/*      /> */}
      {/*    ) */}
      {/*    return textField */}
      {/*  }} */}
      {/*  error={(castErrors[propName] != null)} */}
      {/*  onChange={(select) => { */}
      {/*    logOT.debug('select', select) */}
      {/*    setValue('startDate', select) */}
      {/*    logOT.debug('textField', textField) */}
      {/*    logOT.debug('register', register) */}
      {/*    logOT.debug('register(propName)', register(propName)) */}
      {/*    // register(propName).onChange({ target: { name: 'startDate' }, value: select }) */}
      {/*    return select */}
      {/*  }} */}
      {/* /> */}
      <Typography variant="inherit" color="textSecondary">
        {errors[propName]?.message}
      </Typography>
    </React.Fragment>
  )
}
